// A lista dos modelos na barra lateral: dobra-se e muda de altura, para
// não tirar espaço à estrutura espacial. É uma preferência de quem usa
// (localStorage), não trabalho: não entra na recuperação de sessão.

export const CHAVE_LISTA_DOS_MODELOS = 'vn2r.sidebar.modelos'

export const ALTURA_POR_OMISSAO = 240
export const ALTURA_MINIMA = 60
/** Fracção máxima da barra lateral que a lista pode ocupar. */
export const FRACCAO_MAXIMA = 0.7

export interface PreferenciaDaLista {
  aberta: boolean
  altura: number
}

export const PREFERENCIA_POR_OMISSAO: PreferenciaDaLista = { aberta: true, altura: ALTURA_POR_OMISSAO }

/** A altura dentro dos limites: nunca abaixo do mínimo nem acima da
 *  fracção máxima da barra lateral (quando se sabe a altura dela). */
export function limitarAltura(altura: number, alturaDaBarra?: number): number {
  const maxima = alturaDaBarra && alturaDaBarra > 0
    ? Math.max(ALTURA_MINIMA, Math.floor(alturaDaBarra * FRACCAO_MAXIMA))
    : Number.POSITIVE_INFINITY
  if (!Number.isFinite(altura)) return ALTURA_POR_OMISSAO
  return Math.round(Math.min(maxima, Math.max(ALTURA_MINIMA, altura)))
}

export function lerPreferencia(store: Pick<Storage, 'getItem'> | null = guardado()): PreferenciaDaLista {
  try {
    const raw = store?.getItem(CHAVE_LISTA_DOS_MODELOS)
    if (!raw) return PREFERENCIA_POR_OMISSAO
    const o = JSON.parse(raw) as Partial<PreferenciaDaLista>
    return {
      aberta: typeof o.aberta === 'boolean' ? o.aberta : true,
      altura: typeof o.altura === 'number' ? limitarAltura(o.altura) : ALTURA_POR_OMISSAO,
    }
  } catch {
    return PREFERENCIA_POR_OMISSAO
  }
}

export function gravarPreferencia(p: PreferenciaDaLista, store: Pick<Storage, 'setItem'> | null = guardado()): void {
  try {
    store?.setItem(CHAVE_LISTA_DOS_MODELOS, JSON.stringify(p))
  } catch {
    /* sem armazenamento: fica só nesta página */
  }
}

function guardado(): Storage | null {
  try {
    return window.localStorage
  } catch {
    return null
  }
}
